import React from 'react';
import { Form } from 'semantic-ui-react';

/**
 * SafeMultiSelect - Custom wrapper around Semantic UI Form.Select
 * Ensures value is always an array when using multiple={true}
 */
const SafeMultiSelect = ({ value, onChange, multiple = true, ...rest }) => {
  const safeValue = Array.isArray(value) ? value : value ? [value] : [];

  const handleChange = (e, { value }) => {
    const newValue = Array.isArray(value) ? value : [value];
    onChange?.(e, { ...rest, value: newValue });
  };

  return (
    <Form.Select
      {...rest}
      multiple={multiple}
      value={safeValue}
      onChange={handleChange}
    />
  );
};

export default SafeMultiSelect;
